import { useMemo } from 'react';
import { Icon } from '../../icons';
import type { AlertType } from '../Alert';

export const useAlertIcon = ({ type }: { type: AlertType }) =>
  useMemo(() => {
    switch (type) {
      case 'error':
        return <Icon icon="close-circle-fill" />;
      case 'info':
        return <Icon icon="information-fill" />;
      case 'neutral':
        return <Icon icon="question-fill" />;
      case 'success':
        return <Icon icon="check-circle-fill" />;
      case undefined:
        return undefined;
      case 'warning':
        return <Icon icon="warning-fill" />;
    }
  }, [type]);
